import { Col, Container, Row } from 'react-bootstrap'
import { ZocksRangePicker } from '../ZocksRangePicker/ZocksRangePicker'
import { TimePicker } from '../TimePicker/TimePicker'
import { useState } from 'react'
import './styles.scss'
import { formatTimeHMS } from '../../apps/professional-app/fa/common/aifeatures/utils'

export interface StartEndPickerProps {
  minEpochInSeconds: number
  maxEpochInSeconds: number
  onStartEndChanged: (start: number, end: number) => void
  disabled?: boolean
}

export const StartEndPicker = ({ minEpochInSeconds, maxEpochInSeconds, onStartEndChanged, disabled }: StartEndPickerProps) => {
  const [startTime, setStartTime] = useState(minEpochInSeconds)
  const [endTime, setEndTime] = useState(maxEpochInSeconds)

  const handleInvalidDateRange = () => {
    setStartTime(minEpochInSeconds)
    setEndTime(maxEpochInSeconds)
  }

  const handleStartTimeChanged = (start: number) => {
    if (start >= endTime) {
      handleInvalidDateRange()
      return
    }
    setStartTime(start)
    onStartEndChanged(start, endTime)
  }

  const handleEndTimeChanged = (end: number): boolean => {
    if (end <= startTime) {
      handleInvalidDateRange()
    }
    setEndTime(end)
    onStartEndChanged(startTime, end)
    return true
  }

  const onRangeChanged = ([start, end]: number[]) => {
    handleStartTimeChanged(start)
    handleEndTimeChanged(end)
  }

  return (
    <Container className='mw-100 w-100 p-0'>
      <Row>
        <Col className='col-2'>
          <TimePicker
            onTimeChanged={handleStartTimeChanged}
            epoch={startTime - minEpochInSeconds}
            minEpochValue={minEpochInSeconds}
            maxEpochValue={maxEpochInSeconds}
            label='Set start'
            disabled={disabled}
          />
        </Col>
        <Col className='col-7 d-flex align-items-center range-picker mx-3'>
          <div className='d-flex flex-column w-100'>
            <ZocksRangePicker
              onValuesChanged={onRangeChanged}
              minValue={minEpochInSeconds}
              maxValue={maxEpochInSeconds}
              startValue={startTime}
              endValue={endTime}
              disabled={disabled}
            />
            <div className='pt-2 d-flex align-bottom  justify-content-between'>
              <div className='paragraph-extra-small zocks-text-gray-700'>Start</div>
              <div className='paragraph-extra-small zocks-text-gray-700'>{formatTimeHMS(maxEpochInSeconds - minEpochInSeconds)}</div>
            </div>
          </div>
        </Col>
        <Col className='col-2 d-flex justify-content-end'>
          <TimePicker
            onTimeChanged={handleEndTimeChanged}
            epoch={endTime - minEpochInSeconds}
            minEpochValue={minEpochInSeconds}
            maxEpochValue={maxEpochInSeconds}
            label='Set end'
            disabled={disabled}
          />
        </Col>
      </Row>
    </Container>
  )
}
